<div class="manuals-wrap">

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-text">
      <div class="page-eyebrow">Documentation</div>
      <h1 class="page-title">User Manuals</h1>
      <p class="page-desc">
        Everything you need to get the most out of WellChron and FracX.
        Open a guide in-browser or download it for offline reference.
      </p>
    </div>
    <div class="header-glyph" aria-hidden="true">
      <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="8" width="44" height="56" rx="4" fill="rgba(96,165,250,0.10)" stroke="rgba(96,165,250,0.30)" stroke-width="1.5"/>
        <rect x="18" y="4" width="44" height="56" rx="4" fill="rgba(96,165,250,0.07)" stroke="rgba(96,165,250,0.18)" stroke-width="1.5"/>
        <line x1="16" y1="26" x2="42" y2="26" stroke="rgba(96,165,250,0.40)" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="16" y1="34" x2="42" y2="34" stroke="rgba(96,165,250,0.28)" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="16" y1="42" x2="34" y2="42" stroke="rgba(96,165,250,0.20)" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
  </div>

  <!-- Cards -->
  <div class="manuals-grid">
    <div
      class="manual-card"
      *ngFor="let manual of visibleManuals"
      [class.has-badge]="manual.badge">

      <div class="card-top">
        <div class="card-icon-wrap">
          <!-- Book icon -->
          <svg *ngIf="manual.icon === 'book'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="9" y1="7" x2="15" y2="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <line x1="9" y1="10.5" x2="15" y2="10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <!-- Bolt icon -->
          <svg *ngIf="manual.icon === 'bolt'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 2L4.5 13.5H11L10 22L19.5 10H13L13 2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Code icon -->
          <svg *ngIf="manual.icon === 'code'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 7L3 12L8 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 7L21 12L16 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="13.5" y1="4.5" x2="10.5" y2="19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>

        <div class="card-badge" *ngIf="manual.badge">
          <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L8.8 4.6L13 5.2L10 8.1L10.7 12.3L7 10.4L3.3 12.3L4 8.1L1 5.2L5.2 4.6L7 1Z" fill="currentColor"/>
          </svg>
          {{ manual.badge }}
        </div>
      </div>

      <div class="card-body">
        <div class="card-subtitle">{{ manual.subtitle }}</div>
        <h2 class="card-title">{{ manual.title }}</h2>
        <p class="card-desc">{{ manual.description }}</p>
      </div>

      <div class="card-divider"></div>

      <div class="card-actions">
        <button class="btn-primary" (click)="openViewer(manual)">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="3" stroke="currentColor" stroke-width="1.6"/>
            <path d="M2 10C3.8 5.5 6.6 3 10 3s6.2 2.5 8 7c-1.8 4.5-4.6 7-8 7s-6.2-2.5-8-7z" stroke="currentColor" stroke-width="1.6"/>
          </svg>
          View Guide
        </button>
        <button class="btn-secondary" (click)="downloadManual(manual, $event)">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3v10M6 9l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 15h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
          Download
        </button>
      </div>
    </div>
  </div>

  <!-- Empty state (no visible manuals — shouldn't normally be visible) -->
  <div class="empty-state" *ngIf="visibleManuals.length === 0">
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="20" stroke="rgba(96,165,250,0.25)" stroke-width="1.5"/>
      <path d="M24 16v8M24 30v2" stroke="rgba(96,165,250,0.5)" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <p>No manuals are available for your account.</p>
  </div>

</div>

<!-- PDF Viewer Overlay -->
<div class="viewer-overlay" *ngIf="viewingManual" (click)="closeViewer()">
  <div class="viewer-panel" (click)="$event.stopPropagation()">

    <div class="viewer-header">
      <div class="viewer-title-wrap">
        <div class="viewer-badge" *ngIf="viewingManual.badge">{{ viewingManual.badge }}</div>
        <span class="viewer-title">{{ viewingManual.title }}</span>
      </div>
      <div class="viewer-actions">
        <button class="viewer-btn download" (click)="downloadManual(viewingManual!, $event)">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3v10M6 9l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 15h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
          Download PDF
        </button>
        <button class="viewer-btn close" (click)="closeViewer()" aria-label="Close">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="viewer-body">
      <iframe
        [src]="viewingManual.assetPath | safe"
        title="{{ viewingManual.title }}"
        type="application/pdf">
      </iframe>
    </div>

  </div>
</div>
